import {
  ETextParamType_OnNetCreatedPlayerID,
  ETextParamType_OnNetPosConnected,
  ETextParamType_OnNetPosDisconnected,
  ETextParamType_OnNetVoiceConnected,
  ETextParamType_OnNetVoiceDisconnected,
  ETextParamType_OnNetLiveVideoStarted,
  ETextParamType_OnNetLiveVideoEnded,
  ETextParamType_OnNetLiveVideoPlay,
  ETextParamType_OnNetLiveVideoStop,
  ETextParamType_OnNetLiveConfirmPlayVideo,
  ETextParamType_OnNetReceiveVoiceJoin,
  ETextParamType_OnNetReceiveVoiceLeave,
  ETextParamType_OnNetLiveConnected,
  ETextParamType_OnNetLiveDisconnected,
  ETextParamType_OnNetLiveRemoteJoin,
  ETextParamType_OnNetLiveRemoteLeave,
  ETextParamType_OnNetEstablishmentFail,
  ETextParamType_OnNetConnectionError,
  ETextParamType_OnNetOperationError,
  ETextParamType_OnNetLobbyingUpdate,
  ETextParamType_OnChangedMicPermissionState
} from '../logics/const';
import {hel_postMessage, hel_setText} from '../logics/moduleCaller';

import type {NotifyIntrinsicKeys, PersonalLobbyData} from '../types/notify';

export enum EHeliMicPermissionState {
  Prompt = 0, // 確認が必要（デフォルト）
  Granted = 1, // 許可
  Denied = 2 // 不許可
}

export const onChangedMicPermissionState = (MicPermissionState: EHeliMicPermissionState): void => {
  hel_postMessage(ETextParamType_OnChangedMicPermissionState, MicPermissionState.toString());
};

export const onNetCreatedPlayerID = (ID: string): void => {
  hel_setText(ETextParamType_OnNetCreatedPlayerID, ID);
};

export const onNetPosConnected = (): void => {
  hel_setText(ETextParamType_OnNetPosConnected, '');
};

export const onNetVoiceConnected = (VoiceID: string | null): void => {
  hel_setText(ETextParamType_OnNetVoiceConnected, VoiceID ?? '');
};

export const onNetLiveConnected = (): void => {
  hel_setText(ETextParamType_OnNetLiveConnected, '');
};

export const onNetPosDisconnected = (): void => {
  hel_setText(ETextParamType_OnNetPosDisconnected, '');
};

export const onNetVoiceDisconnected = (): void => {
  hel_setText(ETextParamType_OnNetVoiceDisconnected, '');
};

export const onNetLiveDisconnected = (): void => {
  hel_setText(ETextParamType_OnNetLiveDisconnected, '');
};

export const onNetReceiveVoiceJoin = (ID: string, Data: string): void => {
  if (globalThis.cef_OnNetReceiveVoiceJoin !== undefined) {
    globalThis.cef_OnNetReceiveVoiceJoin(ID, Data);
  } else {
    const params = ID + ',' + Data;
    hel_setText(ETextParamType_OnNetReceiveVoiceJoin, params);
  }
};

export const onNetReceiveVoiceLeave = (ID: string, Data: string): void => {
  if (globalThis.cef_OnNetReceiveVoiceLeave !== undefined) {
    globalThis.cef_OnNetReceiveVoiceLeave(ID, Data);
  } else {
    const params = ID + ',' + Data;
    hel_setText(ETextParamType_OnNetReceiveVoiceLeave, params);
  }
};

/** 演者の入室 */
export const onNetLiveRemoteJoin = (playerId: string): void => {
  hel_setText(ETextParamType_OnNetLiveRemoteJoin, playerId);
};
/** 演者の退室 */
export const onNetLiveRemoteLeave = (playerId: string): void => {
  hel_setText(ETextParamType_OnNetLiveRemoteLeave, playerId);
};

/** RTCの接続にエラー発生時 */
export const onNetEstablishmentFail = (errorCode?: string): void => {
  hel_setText(ETextParamType_OnNetEstablishmentFail, errorCode ?? '');
};
/** RTCの通信状態にエラー発生時 */
export const onNetConnectionError = (errorCode?: string): void => {
  hel_setText(ETextParamType_OnNetConnectionError, errorCode || '');
};
/** RTC上での操作にエラー発生時 */
export const onNetOperationError = (errorCode?: string): void => {
  hel_setText(ETextParamType_OnNetOperationError, errorCode || '');
};

type LowerCamelSpecial<S extends string> = S extends 'JWT' ? 'jwt' : Uncapitalize<S>;
type KeysToLowerCamelCase<T> = {
  [K in keyof T as LowerCamelSpecial<K & string>]: T[K];
};
/** ロビイング情報更新時に発生 */
export const onNetLobbyingUpdate = (
  lobbyData: KeysToLowerCamelCase<Omit<PersonalLobbyData, NotifyIntrinsicKeys>>
): void => {
  hel_setText(ETextParamType_OnNetLobbyingUpdate, JSON.stringify(lobbyData));
};

/** ストリーミング受信時 */
export const onNetLiveVideoStarted = (): void => {
  hel_setText(ETextParamType_OnNetLiveVideoStarted, '');
};
/** ストリーミング停止時 */
export const onNetLiveVideoEnded = (): void => {
  hel_setText(ETextParamType_OnNetLiveVideoEnded, '');
};

// 実際にパネルに描画開始/停止時
export const onNetLiveVideoPlay = (): void => {
  hel_setText(ETextParamType_OnNetLiveVideoPlay, '');
};
export const onNetLiveVideoStop = (): void => {
  hel_setText(ETextParamType_OnNetLiveVideoStop, '');
};

/** 再生確認ダイアログ呼び出し */
export const onNetLiveConfirmPlayVideo = (): void => {
  hel_setText(ETextParamType_OnNetLiveConfirmPlayVideo, '');
};
